import Tabs from '@/components/Tabs/Tabs';
import './Setting.less';
import { useEffect, useState } from 'react';
import signoutIcon from '@/assets/setting/signout.png';
import avatarIcon from '@/assets/headimg.png';

import { useNavigate } from 'react-router-dom';
import { authService, projectController } from '@/api';
import { useSelector } from 'react-redux';
import { removeToken } from '@/utils/cookie';

export default function Home() {
  const navigate = useNavigate();

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    query();
  }, []);

  const query = async () => {};

  const clickProject = (item) => {
    if (item.type === 0) {
      navigate('/texture/' + item.id);
    }
  };

  const handleSignout = async () => {
    await authService.logout();
    removeToken();
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className="settings-home">
      <div className="settings-container">
        <div className="settings">Settings</div>
        <div className="profile">Profile</div>
        <div className="info">
          <div className="avatar">
            <img src={avatarIcon}></img>
          </div>
          <div className="user-infos">
            <div className="nickname">{userInfo.username}</div>
            <div className="email">{userInfo.email}</div>
          </div>
        </div>
        <div className="free">
          <div className="tip">Feel free to give us feedback</div>
          <a
            className="contact-us"
            href="https://docs.google.com/forms/d/e/1FAIpQLScH-sob8IRghi6DB2FHxY5UDxcz-DEelUlod7Ci5P7CkECfwA/viewform"
            target="_blank">
            Contact Us
          </a>
        </div>
        <div
          className="sign-out"
          onClick={() => {
            handleSignout();
          }}>
          <span>Sign out</span>
          <img src={signoutIcon}></img>
        </div>
      </div>
    </div>
  );
}
